module.exports = __webpack_public_path__ + "img/zanwu.8e4c703e.png";